import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const files = require.context("./store/", true, /\.js$/);
const modules = {};
files.keys().forEach((name) => {
  let mod = name.replace(/(\.\/|\.js)/g, "").split("/");
  modules[mod[mod.length - 1]] = files(name).default;
});

import jQuery from "jquery";
import Auth from "./auth";

export default new Vuex.Store({
  state: {
    api_url: process.env.VUE_APP_API_ENDPOINT,
    ws_url: process.env.VUE_APP_WS_ENDPOINT,
    saving: false,
    loading: true,
    modal: {
      showing: false,
    },
    user: Auth.user.get(),
    error: {
      message: null,
      code: null,
      title: null,
      active: false,
    },
    flash: {
      message: null,
      code: null,
      title: null,
      active: false,
      type: null,
    },
  },
  getters: {
    apiUrl: (state) => {
      return state.api_url;
    },
    wsUrl: (state) => {
      return state.ws_url;
    },
    headers: (state) => {
      return {
        Authorization: `Bearer ${state.auth.token}`,
        common: {
          "X-Requested-With": "XMLHttpRequest",
        },
      };
    },
  },
  mutations: {
    SET_LOADING_STATE: (state, loading) => {
      state.loading = loading;
    },
    SET_SAVING_STATE: (state, saving) => {
      state.saving = saving;
    },

    SET_FLASH: (state, obj) => {
      if (obj) {
        state.flash.type = obj.type;
        state.flash.active = true;
        state.flash.message = obj.message;
        state.flash.code = obj.code;
        state.flash.title = obj.title;
      } else {
        state.flash.type = null;
        state.flash.active = false;
        state.flash.message = null;
        state.flash.code = null;
        state.flash.title = null;
      }
    },
    SHOW_MODAL: (state) => {
      state.modal.showing = true;
    },
    HIDE_MODAL: (state) => {
      state.modal.showing = false;
    },
  },
  actions: {
    showModal: ({ commit }, id) => {
      var idEle = ".modal";
      if (id) {
        idEle = `#${id}`;
      }
      var show = new Promise(function (resolve) {
        commit("SHOW_MODAL");
        resolve();
      });

      show.then(function () {
        jQuery(idEle).modal("show");
      });
    },
    hideModal: (context, id) => {
      var idEle = ".modal";
      if (id) {
        idEle = `#${id}`;
      }
      jQuery(idEle).modal("hide");
    },
    setError({ commit }, error) {
      error.type = "error";
      commit("SET_FLASH", error);
      commit("SET_LOADING_STATE", false);
      commit("SET_SAVING_STATE", false);
    },
    setSuccess({ commit }, obj) {
      obj.type = "success";
      commit("SET_FLASH", obj);
      commit("SET_LOADING_STATE", false);
      commit("SET_SAVING_STATE", false);
    },
  },
  modules: modules,
});
